module.exports = __webpack_public_path__ + "img/de-praktijk-2.19b75d63.jpg";